import Axios from '../utils/Axios';
import AsyncLocalStorage from '../utils/AsyncLocalStorage';

export type signUpType = {
  userId: string;
  userPw: string;
  userPwCheck: string;
  ceoName: string;
  storeName: string;
  businessNumber: string;
  userEmailFront: string;
  userEmailBack: string;
  userPhoneNumber: string;
  email: string;
  authenticationKey: number;
  authenticationNumber: string;
};
export type findForgetIdAuthDataType = {
  user_name: string;
  phone_number: string;
};
export type findForgetPwdAuthDataType = {
  id: string;
  phone_number: string;
};
export type authNumVerifyDataType = {
  user_name: string;
  phone_number: string;
};
export type changePwdByfindPwdDataType = {
  id: string;
  password: string;
  password_check: string;
  key: number;
  store_id: number;
};

const LoginController = {
  staff: {},

  /**
   *  * URL: "/signIn"
   *
   *  * 기능:
   *      * 1. 서버 로그인
   *      * 2. "token","refresh-token","user_token_id"를 asyncStorage 저장
   *      * 3. auth data를 recoil에 저장한다.
   *
   */
  signIn: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_LOGIN_URL + '/api/auth/signin';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[로그인 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },

  // 회원가입
  signUp: async (signUpList: signUpType[]) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/auth/knock/hotel/signUpFirst';
      const response: any = await Axios.post(sUrl, signUpList);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[회원가입 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },

  // 회원가입 카카오톡 인증번호
  signUpPhoneAuth: async (userPhoneNumber: string) => {
    try {
      let sUrl = process.env.REACT_APP_API_BEHIND_URL + '/auth/signUpPhoneAuth';
      const response: any = await Axios.post(sUrl, userPhoneNumber);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[회원가입 휴대폰 인증 오류]' + oErr.toString(),
        data: {},
      };
    }
  },

  // 중복 아이디 체크
  checkDupId: async (userId: string) => {
    try {
      let sUrl = process.env.REACT_APP_API_BEHIND_URL + '/auth/checkDupId/:' + userId;

      const response: any = await Axios.get(sUrl);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[아이디 중복 오류]' + oErr.toString(),
        data: {},
      };
    }
  },

  // 아이디 찾기
  findForgetIdAuth: async (findForgetIdAuthData: findForgetIdAuthDataType[]) => {
    try {
      let sUrl = process.env.REACT_APP_API_BEHIND_URL + '/auth/findForgetIdAuth';
      const response: any = await Axios.post(sUrl, findForgetIdAuthData);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[아이디 찾기 정보 오류]' + oErr.toString(),
        data: {},
      };
    }
  },
  // 비밀번호 찾기
  findForgetPwdAuth: async (findForgetPwdAuthData: findForgetPwdAuthDataType[]) => {
    try {
      let sUrl = process.env.REACT_APP_API_BEHIND_URL + '/auth/findForgetPwdAuth';
      const response: any = await Axios.post(sUrl, findForgetPwdAuthData);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[아이디 찾기 정보 오류]' + oErr.toString(),
        data: {},
      };
    }
  },
  // 아이디 찾기/비밀번호 찾기_카카오톡 인증번호
  authNumVerify: async (authNumVerifyData: authNumVerifyDataType[]) => {
    try {
      let sUrl = process.env.REACT_APP_API_BEHIND_URL + '/auth/authNumVerify';
      const response: any = await Axios.post(sUrl, authNumVerifyData);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[아이디찾기/비밀번호찾기 휴대폰 인증번호 오류]' + oErr.toString(),
        data: {},
      };
    }
  },
  // 비밀번호 변경
  changePwdByfindPwd: async (changePwdByfindPwdData: changePwdByfindPwdDataType[]) => {
    try {
      let sUrl = process.env.REACT_APP_API_BEHIND_URL + '/auth/changePwdByfindPwd';
      const response: any = await Axios.post(sUrl, changePwdByfindPwdData);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[비밀번호 변경 오류]' + oErr.toString(),
        data: null,
      };
    }
  },
  // firebase token
  setWebFirebaseToken: async (oParams: any) => {
    try {
      let sUrl =
        process.env.REACT_APP_API_KNOCKKNOCK_LOGIN_URL + `/api/user/setHotelierFirebaseToken`;

      const response: any = await Axios.post(sUrl, oParams);
      console.log('setHotelierFirebaseToken', response);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[Firebase Token 오류]' + oErr.toString(),
        data: null,
      };
    }
  },
  // logout
  logout: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_LOGIN_URL + `/api/user/logout`;

      const response: any = await Axios.post(sUrl, oParams);
      console.log('logout', response);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[로그아웃 오류]' + oErr.toString(),
        data: null,
      };
    }
  },

  logToServer: async (oData: any) => {
    let oPost = {
      log: JSON.stringify(oData),
    };
    // UtilController.logToServer(oPost)
  },
};

export default LoginController;
